//
//
//
//
//
//

export default {
  name: 'DpTableBody',
};
